'use client';

// Cream sand base + grain noise + top-light vignette. Pure CSS, no JS.
// Inline SVG turbulence noise replaces a raster asset.

const NOISE_SVG = encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" width="240" height="240">
    <filter id="n">
      <feTurbulence type="fractalNoise" baseFrequency="0.85" numOctaves="2" seed="3"/>
      <feColorMatrix values="0 0 0 0 0.16  0 0 0 0 0.14  0 0 0 0 0.10  0 0 0 0.45 0"/>
    </filter>
    <rect width="100%" height="100%" filter="url(#n)" opacity="0.4"/>
  </svg>`,
);

export function SandTexture() {
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        inset: 0,
        pointerEvents: 'none',
        zIndex: 0,
        background: '#e8dcc4',
        backgroundImage: `
          radial-gradient(ellipse at 50% -10%, rgba(255,250,240,0.35) 0%, transparent 55%),
          url("data:image/svg+xml;utf8,${NOISE_SVG}")
        `,
        backgroundRepeat: 'no-repeat, repeat',
        backgroundSize: 'cover, 240px 240px',
      }}
    />
  );
}
